/**
 * Generated by orval v8.17.0 🍺
 * Do not edit manually.
 * MDLink
 * In the documentation API requests will be sent from currently logged in user so you do not need to provide a bearer token manually. <br><br> When calling API from outside the documentation, you will need to provide an access token for all requests in authorization header: `Authorization: Bearer <Token>` <br> You can create a new access token in your account settings page.
 * OpenAPI spec version: 1.0.0
 */
import type {CreateCustomDomain200} from './schemas/create-custom-domain200';

import type {ListCustomDomainsParams} from './schemas/list-custom-domains-params';

import type {ListCustomDomains200} from './schemas/list-custom-domains200';

import type {RetrieveCustomDomain200} from './schemas/retrieve-custom-domain200';

import type {SaveCustomDomainRequest} from './schemas/save-custom-domain-request';

import type {UpdateCustomDomain200} from './schemas/update-custom-domain200';

import {orvalApiFetch} from '../../../common/foundation/resources/client/http/query-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List all custom domains
 */
export const listCustomDomains = (
  params?: ListCustomDomainsParams,
  options?: SecondParameter<typeof orvalApiFetch<ListCustomDomains200>>,
) => {
  return orvalApiFetch<ListCustomDomains200>(
    {url: `/custom-domains`, method: 'GET', params},
    options,
  );
};
/**
 * @summary Create a custom domain
 */
export const createCustomDomain = (
  saveCustomDomainRequest?: SaveCustomDomainRequest,
  options?: SecondParameter<typeof orvalApiFetch<CreateCustomDomain200>>,
) => {
  return orvalApiFetch<CreateCustomDomain200>(
    {
      url: `/custom-domains`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: saveCustomDomainRequest,
    },
    options,
  );
};
/**
 * @summary Retrieve a custom domain
 */
export const retrieveCustomDomain = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<RetrieveCustomDomain200>>,
) => {
  return orvalApiFetch<RetrieveCustomDomain200>(
    {url: `/custom-domains/${id}`, method: 'GET'},
    options,
  );
};
/**
 * @summary Update a custom domain
 */
export const updateCustomDomain = (
  id: number,
  saveCustomDomainRequest?: SaveCustomDomainRequest,
  options?: SecondParameter<typeof orvalApiFetch<UpdateCustomDomain200>>,
) => {
  return orvalApiFetch<UpdateCustomDomain200>(
    {
      url: `/custom-domains/${id}`,
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      data: saveCustomDomainRequest,
    },
    options,
  );
};
/**
 * @summary Delete a custom domain
 */
export const deleteCustomDomain = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/custom-domains/${id}`, method: 'DELETE'},
    options,
  );
};
/**
 * @summary Archive a custom domain
 */
export const archiveCustomDomain = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/custom-domains/${id}/archive`, method: 'POST'},
    options,
  );
};
/**
 * @summary Unarchive a custom domain
 */
export const unarchiveCustomDomain = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/custom-domains/${id}/unarchive`, method: 'POST'},
    options,
  );
};
export type ListCustomDomainsResult = NonNullable<
  Awaited<ReturnType<typeof listCustomDomains>>
>;
export type CreateCustomDomainResult = NonNullable<
  Awaited<ReturnType<typeof createCustomDomain>>
>;
export type RetrieveCustomDomainResult = NonNullable<
  Awaited<ReturnType<typeof retrieveCustomDomain>>
>;
export type UpdateCustomDomainResult = NonNullable<
  Awaited<ReturnType<typeof updateCustomDomain>>
>;
export type DeleteCustomDomainResult = NonNullable<
  Awaited<ReturnType<typeof deleteCustomDomain>>
>;
export type ArchiveCustomDomainResult = NonNullable<
  Awaited<ReturnType<typeof archiveCustomDomain>>
>;
export type UnarchiveCustomDomainResult = NonNullable<
  Awaited<ReturnType<typeof unarchiveCustomDomain>>
>;
